import { AxiosResponse } from 'axios';
import { useQueryClient } from '@tanstack/react-query';

export function useQueryClientData(queryKey: string[]) {
  const queryClient = useQueryClient();
  const detailsData = queryClient.getQueryData(queryKey) as AxiosResponse;

  return detailsData?.data;
}
export default useQueryClientData;
